import {SET_KUMULOS} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  
  selectedData: null,
  formType: "",
  formId: "",
  formTitle: "",

  isLoading: false,
  isExporting: false,
  data: [],
  count: 0,
  activePage: 1,
  limit: 10
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case SET_KUMULOS:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/Kumulos.js